<template>
    <PageFrameContainer>
        <div class="faqs-section">
            <div class="left">
                <MainPageFAQCard
                        :title="$t('pages.pricing.faq.needCard.title')">
                    {{$t('pages.pricing.faq.needCard.text')}}
                </MainPageFAQCard>
                <MainPageFAQCard
                        :title="$t('pages.pricing.faq.featuresFreeCard.title')">
                    {{$t('pages.pricing.faq.featuresFreeCard.text')}}
                </MainPageFAQCard>
                <MainPageFAQCard
                        :title="$t('pages.pricing.faq.unsubscribeCard.title')">
                    {{$t('pages.pricing.faq.unsubscribeCard.text')}}
                </MainPageFAQCard>
            </div>
            <div class="right">
                <MainPageFAQCard
                        :title="$t('pages.pricing.faq.perpetualCard.title')">
                    {{$t('pages.pricing.faq.perpetualCard.text')}}
                </MainPageFAQCard>
                <MainPageFAQCard
                        :title="$t('pages.pricing.faq.increaseCard.title')">
                    {{$t('pages.pricing.faq.increaseCard.text')}}
                </MainPageFAQCard>
            </div>
        </div>
    </PageFrameContainer>
</template>

<script>
    import MainPageFAQCard from "../parts/../../main/parts/MainPageFAQCard";
    import PageFrameContainer from "../../../components/PageFrameContainer";


    export default {
        name: "PricingFaqAndContactSection",
        components: {PageFrameContainer, MainPageFAQCard}
    }
</script>

<style scoped lang="scss">
    @import "../../../theme/theme";

    .faqs-section {
        display: grid;
        grid-template-columns: 1fr 1fr;
        margin-top: 1em;
        margin-bottom: 1em;
        @media (max-width: 55em) {
            grid-template-columns: 1fr;
            margin-bottom: 1em;
        }
    }

</style>